window.addEventListener("DOMContentLoaded", () => {
  const submitButtons: NodeListOf<HTMLButtonElement> = document.querySelectorAll(".FormSubmitButton.button") as NodeListOf<HTMLButtonElement>;

  // Scroll to the top of the form when the submit button is clicked
  submitButtons.forEach((submitButton: HTMLButtonElement) => {
    submitButton.addEventListener("click", () => {
      const form: HTMLFormElement = submitButton.closest(".EPiServerForms") as HTMLFormElement;
      form.scrollIntoView({behavior: "smooth"});
    });
  });
});